import { getDaysInMonth } from './timeUtils';
export const sideNav = {
  // getEmpSideNav: (emps) => {
  //     let deps = emps.reduce((deps, emp) => {
  //         let dep = emp.department.toLowerCase()
  //         if (!deps.includes(dep)) deps.push(dep)
  //         return deps
  //     }, [])
  //     deps = deps.map(dep => ({
  //         title: dep[0].toUpperCase() + dep.substr(1),
  //         path: '/dashboard/employee?dep='
  //     }))
  //     deps.unshift({ title: 'Enseñar Baja', path: '/dashboard/employee?baja=', isSubtitle: true })
  //     deps.unshift({ title: 'Todos', path: '/dashboard/employee' })
  //     return deps
  // },
  reports: [
    // { title: 'Planilla Central', path: '/dashboard/planilla', isDisabled: true },
    {
      title: 'Asistencia Mensual',
      path: '/dashboard/planilla/attend?type=mensual',
    },
    {
      title: 'Asistencia Diaria',
      path: '/dashboard/planilla/attend?type=diaria',
    },
    // { title: 'Atendencia', path: 'mdi-view-dashboard' },
  ],
};

export const tableHeader = {
  payrollReport: [
    { text: 'Codigo', value: 'cId' },
    { text: 'Nombre', value: 'name' },
    { text: 'Finca', value: 'farm' },
    { text: 'Puesto', value: 'post' },
    { text: 'Departamento', value: 'department' },
    { text: 'Cuenta Bancaria', value: 'bankAcc' },
    { text: 'Mensual Nomina', value: 'monthlySalaryNomina' },
    { text: 'Diario Nomina', value: 'salaryNomina' },
    { text: 'Mensual Ayco', value: 'monthlySalaryAyco' },
    { text: 'Diario Ayco', value: 'salaryAyco' },
    { text: 'Dias Quincenal', value: 'totalDays' },
    { text: 'Total Horas', value: 'extraHours' },
    { text: 'Ayco - Valor Hora', value: 'hourAyco' },
    { text: 'Ayco - Monto Quincenal', value: 'monthSalaryAyco' },
    { text: 'Ayco - Extras', value: 'extraValueAyco' },
    { text: 'Ayco - Total a Recibir', value: 'totalSalaryAyco' },
    { text: 'Nomina - Valor Hora', value: 'hourNomina' },
    { text: 'Nomina - Monto Quincenal', value: 'monthSalaryNomina' },
    { text: 'Nomina - Extras', value: 'extraValueNomina' },
    { text: 'Nomina - Total a Recibir', value: 'totalSalaryNomina' },
    { text: 'Cafeteria San Jose', value: 'shop.sanJose' },
    { text: 'Cafeteria El Paso', value: 'shop.elPaso' },
    { text: 'Cafeteria San Jorge', value: 'shop.sanJorge' },
    { text: 'Aticipio', value: 'loan' },
    { text: 'Total Descuentos', value: 'totalDisc' },
    { text: 'Otros Ingresos', value: 'bonus' },
    { text: 'Liquido a Recibir', value: 'total' },
  ],
  depReport: (era, date) => {
    const headers = [];
    const firstDay = era === 1 ? 1 : 16;
    const lastDay = era === 1 ? 15 : getDaysInMonth(date);
    for (let i = firstDay; i <= lastDay; i++) {
      headers.push({ text: i, value: 'day' + i });
    }
    headers.unshift({ text: 'Nombre', value: 'name' });
    headers.push({ text: 'Costo Mensual', value: 'total' });
    return headers;
  },
  // depReport: [
  //     { text: 'Nombre', value: 'name' },
  //     { text: 'Costo Diario', value: 'dailyCost' },
  //     { text: 'Costo Mensual', value: 'monthlyCost' },
  // ],
  attendReport: [
    { text: 'Codigo', value: 'cId', sortable: true },
    { text: 'Nombre', sortable: true, value: 'name' },
    { text: 'Departamento', value: 'department', sortable: true },
    { text: 'Puesto', value: 'post' },
    { text: 'Extra Horas', value: 'extraHours' },
    { text: 'Total Dias', value: 'totalDays' },
  ],
  emp: [
    { text: 'Codigo', value: 'cId', sortable: true, groupable: false },
    { text: 'Nombre', sortable: true, value: 'name', groupable: false },
    { text: 'Departamento', value: 'department', sortable: true },
    { text: 'Puesto', value: 'post', groupable: false },
    { text: 'Salud', value: 'health', groupable: false },
    { text: 'Huellas Enroladas', value: 'fpEnrolledCount', groupable: false },
    { text: 'Ingreso', value: 'entry', groupable: false },
    { text: 'Baja', value: 'exit', groupable: false },
    // { text: 'Baja', value: 'exit' },

    { text: 'Acciones', value: 'actions', sortable: false, groupable: false },
  ],
  attend: [
    { text: 'Codigo', value: 'cId', sortable: true },
    { text: 'Imagen', value: 'img', sortable: false },
    { text: 'Nombre', sortable: true, value: 'name' },
    { text: 'Departamento', value: 'department', sortable: true },
    { text: 'Puesto', value: 'post' },
    { text: 'Horas Extra', value: 'extraHours' },
    { text: 'Asistencia', value: 'isAttend', sortable: true },
  ],
  user: [
    { text: 'Nombre', sortable: true, value: 'username' },
    { text: 'Es Admin', sortable: true, value: 'isAdmin' },
    { text: 'Es Editor', sortable: true, value: 'isEditor' },
    { text: 'Es Supervisor', sortable: true, value: 'isSupervisor' },
    { text: 'Acciones', value: 'actions', sortable: false },
  ],
  population: [
    { text: 'Departemanto', sortable: true, value: 'name' },
    { text: 'Monto', sortable: true, value: 'monto' },
    { text: 'Baja', sortable: true, value: 'baja' },
    { text: 'Suspendido', value: 'suspend', sortable: true },
    { text: 'Actual', value: 'actual', sortable: true },
  ],
};

export const FpVariantEnum = {
  // Left Thumb
  l1: 1,
  // Left Index
  l2: 2,
  // Right Thumb
  r1: 3,
  // Right Index
  r2: 4,
};
export const FpVariantToName = {
  [FpVariantEnum.l1]: 'Pulgar Izquierdo',
  [FpVariantEnum.l2]: 'Indice Izquierdo',
  [FpVariantEnum.r1]: 'Pulgar Derecho',
  [FpVariantEnum.r2]: 'Indice Derecho',
};
